import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Card,
  Form,
  Alert,
  Spinner,
  InputGroup,
  DropdownDivider,
} from "react-bootstrap";
import GeneralInformation from "./GeneralInformationForm";
import Stepper from "../../components/Stepper";
// import ContactDetailsForm from "./ContactDetailsForm";
import PaymentAndShippingForm from "./PaymentAndShippingForm";
import OtherDetailsForm from "./OtherDetailsForm";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import {
  IconArrowNarrowLeftDashed,
  IconArrowNarrowRightDashed,
} from "@tabler/icons-react";
// import "./NewQuote.css";
import { useForm, FormProvider, useFormContext } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import { toast } from "react-toastify";
import SalesLead from "./SalesLead";
import Attachment from "./Attachment";
import { format } from "date-fns";
import SuccsessMsgModal from "../../components/SuccessMsgModal";
import { isValidPhoneNumber } from "react-phone-number-input";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Notes from "../../components/Notes/Notes";
import PriceChange from "./PriceChange";
import useIdleLogout from "../../hooks/useIdleLogout";
import { trimTrailingZeros } from "../../utils/_helpers";
import { usePostHog } from "@posthog/react";

const PORT = process.env.REACT_APP_BASE_URL;

const generateUniqueId = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  let result = "";
  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  const timestamp = Date.now().toString();
  const uniqueId = result + timestamp.slice(-4);
  return uniqueId;
};

function CreateProject() {
  const location = useLocation();
  const { selectedCopy, rfqCopy } = location.state || {};
  const [initialVal, setInitialVal] = useState(1);
  const [serverErr, setServerErr] = useState([]);
  const [show, setShow] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [rfqDataFetched, setRfqDataFetched] = useState(false);
  const [rfqDataFetchedcopy, setRfqDataFetchedcopy] = useState(false);
  const posthog = usePostHog();
  const [formId, setFormId] = useState(null);
  const [contractTypeId, setContractTypeId] = useState(null);
  const [contractVehicleTypeState, setContractVehicleTypeState] = useState("");

  // console.log("contractVehicleTypeState", contractVehicleTypeState);

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    message: "",
    btntext: "",
    title: "",
  });

  const [rfqstatus, setRfqStatus] = useState();

  const handleStatusChange = (event) => {
    setRfqStatus(event.target.value);
  };

  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);

  const { rfq_id } = useParams();

  const schema = yup.object().shape({
    // step 1
    notes: yup.array().of(
      yup.object().shape({
        section: yup.string().required("Section is required"),
        notesdata: yup.array().of(
          yup.object().shape({
            note: yup.string().required("Note cannot be blank"),
          }),
        ),
      }),
    ),

    // NEW CHANGES
    opportunityName: yup.string().required("Name is required"),
    contract_vehicle_type: yup
      .string()
      .required("Contract vehicle type is required"),
    code: yup
      .string()
      .matches(
        /^[a-zA-Z0-9/ .\-–—]+$/,
        "Abbreviation can contain only letters, numbers, spaces, /, -, – , — and dots",
      )
      .required("Abbreviation is required")
      .max(5, "Abbreviation must be at most 5 characters"),

    // opportunityName: yup.string().optional(),
    rfqId: yup
      .string()
      // .min(1, "Project ID required.")
      .matches(
        /^[a-zA-Z0-9/ .\-–—]+$/,
        "ID can contain only letters, numbers, spaces, /, -, – , — and dots",
      )
      .required("Project ID required."),
    // contractVehicle: yup
    //   .number()
    //   .transform((value) => (value === "" ? null : value))
    //   .typeError("required.")
    //   .required("required.")
    //   .test("is-valid-number", "not nagetive.", (value) => {
    //     return value === null || (!isNaN(value) && value !== -1);
    //   }),
    publishedDate: yup.date().required("Published Date is required"),
    start_date: yup.date().required("Start Date is required"),
    // due_date: yup.date().nullable(),
    due_date: yup
      .date()
      .nullable()
      .when("contract_vehicle_type", {
        is: (value) => value && value.includes("time-bound"),
        then: (schema) => schema.required("End date is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    emails: yup.string().nullable(),

    // dueDate: yup.date().required("Due Date is required"),
    organization_name: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable()
      .min(2, "Must be at least 2 character")
      .max(100, "Must be at most 100 characters"),

    Opportunity_Description: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable()
      .min(5, "Must be at least 5 characters")
      .max(500, "Must be at most 500 characters"),

    project_duration: yup
      .number()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value,
      )
      .typeError("Duration must be a number")
      .min(0, "Duration must be 0 or more")
      .integer("Duration must be an integer")
      .nullable(),

    // project_budget: yup
    //   .number()
    //   .transform((value, originalValue) => {
    //     return originalValue === "" || originalValue === undefined
    //       ? null
    //       : value;
    //   })
    //   .nullable()
    //   .typeError("Project Budget must be a number")
    //   .test(
    //     "is-valid-budget",
    //     "Project Budget must be greater than or equal to zero",
    //     (value) => value === null || value >= 0
    //   ),

    project_budget: yup
      .number()
      .transform((value, originalValue) => {
        return originalValue === "" || originalValue === undefined
          ? null
          : value;
      })
      .nullable()
      .typeError("Project Budget must be a number")
      .when("contract_vehicle_type", {
        is: (value) => value && value.includes("budget-bound"),
        then: (schema) =>
          schema
            .required("Project Budget is required")
            .test(
              "is-valid-budget",
              "Project Budget must be greater than or equal to zero",
              (value) => value === null || value >= 0,
            ),
        otherwise: (schema) => schema.notRequired(),
      }),

    custom_fields: yup.array().of(
      yup.object().shape({
        // field_name: yup.string().required("Field name is required"),
        // value: yup.string().required("required"),
        field_name: yup.string().required("Field name is required"),
        value: yup.string().optional(),
      }),
    ),

    contractPocName: yup.string().optional(),
    contractPocEmail: yup
      .string()
      .optional()
      .email("Email must be a valid email address"),

    contractPocPhone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable(),
    // .test("valid-phone", "Invalid phone number", (value) => {
    //   if (!value) {
    //     return true;
    //   }
    //   if (typeof value === "string" && value.trim() !== "") {
    //     return isValidPhoneNumber(value);
    //   }
    //   return false;
    // })
    // .optional(),

    // price_changes: yup.array().of(
    //   yup.object().shape({
    //     sku_id: yup.string().required(),
    //     // from_date: yup.string().required(),
    //     // to_date: yup.string().required(),
    //     customer_price: yup
    //       .number()
    //       .typeError("Must be a number")
    //       .required("Required")
    //       .min(0, "Must be at least 0"),
    //     margin_percent: yup.number().optional(),
    //   })
    // ),

    //  step 2
    estimateddelivery: yup.string().optional(),
    payment_terms: yup.string().optional(),
    payment_term_detail: yup.string().nullable(),
    shipping_method: yup.string().optional(),
    shipping_method_detail: yup.string().optional(),

    // shipping_method_detail: yup.string().optional(),
    contractOfficerName: yup.string().nullable(),
    contractOfficerEmail: yup
      .string()
      .nullable()
      .email("Email must be a valid email address"),

    contractOfficerPhone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable(),
    // .test("valid-phone", "Invalid phone number", (value) => {
    //   if (!value) {
    //     return true;
    //   }
    //   if (typeof value === "string" && value.trim() !== "") {
    //     return isValidPhoneNumber(value);
    //   }
    //   return false;
    // })
    // .optional(),
    contractOfficerAddress: yup.string().nullable(),
    shippingCustomerName: yup.string().nullable(),
    shippingCustomerEmail: yup
      .string()
      .nullable()
      .email("Email must be a valid email address"),
    shippingCustomerPhone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable(),
    // .test("valid-phone", "Invalid phone number", (value) => {
    //   if (!value) {
    //     return true;
    //   }
    //   if (typeof value === "string" && value.trim() !== "") {
    //     return isValidPhoneNumber(value);
    //   }
    //   return false;
    // })
    // .optional(),
    shippingCustomerAddress: yup.string().nullable(),
    BillingCustomerName: yup.string().nullable(),
    BillingCustomerEmail: yup
      .string()
      .nullable()
      .email("Email must be a valid email address"),
    BillingCustomerPhone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable(),
    // .test("valid-phone", "Invalid phone number", (value) => {
    //   if (!value) {
    //     return true;
    //   }
    //   if (typeof value === "string" && value.trim() !== "") {
    //     return isValidPhoneNumber(value);
    //   }
    //   return false;
    // })
    // .optional(),
    // BillingCustomerPhone: yup
    //   .string()
    //   .transform((value) => (value === "" ? null : value))
    //   .nullable()
    //   .min(10, "Phone number must be at least 10 digits")
    //   .optional(),
    BillingCustomerAddress: yup.string().nullable(),
    // sales lead
    // sales_lead_username: yup.string().required("Sales Lead Username is required")

    sales_lead_name: yup.string().required("Sales Lead Name is required"),
    sales_lead_email: yup
      .string()
      .email("Email must be a valid email address")
      .required("Sales Lead Email is required"),
    sales_lead_phone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .min(10, "Phone number must be at least 10 digits")
      .required("Sales Lead Phone is required"),

    notification_emails: yup.array().of(yup.string().email("Invalid email")),

    rfqwon_notification_emails: yup
      .array()
      .of(yup.string().email("Invalid email")),
    orderpending_notification_emails: yup
      .array()
      .of(yup.string().email("Invalid email")),

    orderprogress_notification_emails: yup
      .array()
      .of(yup.string().email("Invalid email")),

    // sales_lead_name: yup.string().required("Sales Lead Name is required"),

    // Notes: yup.array().of(
    //   yup.object().shape({
    //     description: yup
    //       .string()
    //       .transform((value) => (value === "" ? null : value))
    //       .nullable()
    //       .min(10, "Description must be at least 10 characters")
    //       .max(200, "Description must be at most 200 characters")
    //       .optional(),
    //   })
    // ),

    otherCost: yup.array().of(
      yup.object({
        Name: yup.string().required(),
        Amount: yup
          .number()
          .transform((value) => (value === "" ? null : value))
          .typeError("Must be a number.")
          .required("required.")
          .test("is-valid-number", "not nagetive.", (value) => {
            return value === null || (!isNaN(value) && value !== -1);
          })
          .min(1, "at least 1."),
      }),
    ),

    cards: yup.array().of(
      yup.object({
        vendorPartner: yup.string().nullable(),
        productName: yup.string().nullable().optional(),
        skuId: yup.string().nullable(),
        clin: yup.string().nullable(),
        skuDescription: yup.string().nullable(),
        // .required("Description is required.")
        // .min(5, "Description must be at least 5 characters."),
        // .max(100, "Description must be at most 100 characters."),
        cost: yup
          .number()
          .transform((value, originalValue) => {
            return originalValue === "" || originalValue === undefined
              ? null
              : value;
          })
          .nullable()
          .typeError("Must be a number.")
          .test("is-valid-number", "not negative.", (value) => {
            return value === null || (!isNaN(value) && value >= 0);
          }),

        // qty: yup
        //   .number()
        //   .transform((value, originalValue) => {
        //     return originalValue === "" || originalValue === undefined
        //       ? null
        //       : value;
        //   })
        //   .nullable()
        //   .typeError("Must be a number.")
        //   .test("is-valid-number", "Must not be negative.", (value) => {
        //     return value === null || (!isNaN(value) && value >= 0);
        //   }),

        ...(contractVehicleTypeState?.includes("product-bound")
          ? {
              qty: yup
                .number()
                .transform((value, originalValue) => {
                  if (
                    originalValue === "" ||
                    originalValue === undefined ||
                    originalValue === null
                  ) {
                    return null;
                  }
                  const parsed = Number(originalValue);
                  return isNaN(parsed) ? null : parsed;
                })
                .nullable()
                .typeError("Must be a number.")
                .required("Quantity is required")
                // .min(1, "Quantity must be at least 1"),
                .moreThan(0, "Quantity must be greater than 0"),
            }
          : {
              qty: yup
                .number()
                .transform((value, originalValue) => {
                  if (
                    originalValue === "" ||
                    originalValue === undefined ||
                    originalValue === null
                  ) {
                    return null;
                  }
                  const parsed = Number(originalValue);
                  return isNaN(parsed) ? null : parsed;
                })
                .nullable()
                .typeError("Must be a number.")
                .notRequired()
                .min(0, "Must not be negative."),
            }),

        // qty: yup
        //   .number()
        //   .transform((value) => (value === "" ? null : value))
        //   .typeError("Must be a number.")
        //   // .required("required.")
        //   .test("is-valid-number", "not nagetive.", (value) => {
        //     return value === null || (!isNaN(value) && value !== -1);
        //   }),
        // // .min(1, "at least 1."),

        margin: yup
          .number()
          .transform((value, originalValue) => {
            return originalValue === "" || originalValue === undefined
              ? null
              : value;
          })
          .nullable()
          .typeError("Must be a number.")
          .test("is-valid-number", "not negative.", (value) => {
            return value === null || (!isNaN(value) && value >= 0);
          }),

        customerCost: yup
          .number()
          .transform((value, originalValue) => {
            return originalValue === "" || originalValue === undefined
              ? null
              : value;
          })
          .nullable()
          .typeError("Must be a number.")
          .test("is-valid-number", "not negative.", (value) => {
            return value === null || (!isNaN(value) && value >= 0);
          }),
        um: yup.string().nullable(),
      }),
    ),
  });

  useIdleLogout();

  const transformData = (resData) => {
    return {
      notes: resData.map((section) => ({
        section: section.name,
        custom_id: section.custom_id,
        notesdata: section.notes.map((noteItem) => ({
          note: noteItem.note,
          user: noteItem.User.username,
          updateAt: noteItem.updated_at,
          custom_id: noteItem.custom_id || undefined,
        })),
      })),
    };
  };

  const onSingleNotesSuccess = (res) => {
    if (res?.data) {
      const transformedData = transformData(res.data);
      setValue("notes", transformedData.notes);
    }
  };

  const onSingleProjectSuccess = (rfq) => {
    if (rfq?.data) {
      if (rfq?.data?.attachment_id) {
        setFormId(rfq?.data?.attachment_id);
      }

      setContractTypeId(rfq?.data?.ContractType?.id || null);

      setValue(
        "opportunityName",
        rfq?.data?.opportunity_name ? rfq?.data?.opportunity_name : "",
      );
      setValue("rfqId", rfq?.data?.rfq_id ? rfq?.data?.rfq_id : null);

      setValue(
        "contractVehicle",
        rfq?.data?.ContractType?.parent_id
          ? rfq?.data?.ContractType?.parent_id
          : null,
      );
      setValue("order_Payment_Type", rfq?.data?.order_payment_type);
      setValue("ordertype", rfq?.data?.order_type);
      setValue(
        "organization_name",
        rfq?.data?.organization_name ? rfq?.data?.organization_name : "",
      );

      setValue(
        "contract_vehicle_type",
        rfq?.data?.ContractType?.contract_vehicle_type
          ? rfq?.data?.ContractType?.contract_vehicle_type
          : "",
      );

      setValue(
        "Opportunity_Description",
        rfq?.data?.brief ? rfq?.data?.brief : "",
      );
      setValue(
        "publishedDate",
        rfq?.data?.published_date
          ? moment(rfq?.data?.published_date).format("MM/DD/YYYY")
          : null,
      );
      setValue(
        "start_date",
        rfq?.data?.start_date
          ? moment(rfq?.data?.start_date).format("MM/DD/YYYY")
          : null,
      );
      setValue(
        "due_date",
        rfq?.data?.due_date
          ? moment(rfq?.data?.due_date).format("MM/DD/YYYY")
          : null,
      );
      setValue(
        "code",
        rfq?.data?.ContractType?.letter
          ? rfq?.data?.ContractType?.letter
          : null,
      );
      setValue(
        "emails",
        rfq?.data?.team_emails ? rfq?.data?.team_emails : null,
      );
      setValue(
        "project_duration",
        rfq?.data?.project_duration ? rfq?.data?.project_duration : null,
      );
      setValue(
        "project_budget",
        rfq?.data?.project_budget ? rfq?.data?.project_budget : null,
      );

      const parsedCosts = rfq?.data?.other_cost_json
        ? JSON.parse(rfq.data.other_cost_json)
        : [];
      parsedCosts.forEach((cost, index) => {
        setValue(`otherCost[${index}].Name`, cost?.Name);
        setValue(`otherCost[${index}].Amount`, cost?.Amount);
      });

      setValue("tax", rfq?.data?.tax);
      setValue("shippingCost", rfq?.data?.shipping_cost);
      setValue("totalCostAfterMargin", rfq?.data?.total_cost_after_margin);
      setValue("totalCostBeforeMargin", rfq?.data?.total_cost_before_margin);
      setInitialVal(0);

      const emailsString = rfq?.data?.team_emails;
      const emailsArray = emailsString ? emailsString.split(",") : [];
      setValue("notification_emails", emailsArray);

      const rfqwonEmailsString = rfq?.data?.rfq_won_notification_emails;
      const rfqwonEmailsArray = rfqwonEmailsString
        ? rfqwonEmailsString.split(",")
        : [];
      setValue("rfqwon_notification_emails", rfqwonEmailsArray);

      const orderpendingEmailsString =
        rfq?.data?.order_pending_notification_emails;
      const orderpendingEmailsArray = orderpendingEmailsString
        ? orderpendingEmailsString.split(",")
        : [];
      setValue("orderpending_notification_emails", orderpendingEmailsArray);

      const orderprogressEmailsString =
        rfq?.data?.order_progress_notification_emails;
      const orderprogressEmailsArray = orderprogressEmailsString
        ? orderprogressEmailsString.split(",")
        : [];
      setValue("orderprogress_notification_emails", orderprogressEmailsArray);

      setValue("notifyEmails", rfq?.data?.notify_emails === 1 ? "1" : "0");
      setValue(
        "notifyEmailsVendor",
        rfq?.data?.notify_emails_vendor === 1 ? "1" : "0",
      );

      setValue(
        "sales_lead_email",
        rfq?.data?.sales_lead_email ? rfq?.data?.sales_lead_email : "",
      );
      setValue(
        "sales_lead_name",
        rfq?.data?.sales_lead_name ? rfq?.data?.sales_lead_name : "",
      );

      setValue(
        "sales_lead_name",
        rfq?.data?.sales_lead_name ? rfq?.data?.sales_lead_name : "",
      );
      setValue(
        "sales_lead_username",
        rfq?.data?.sales_lead_username ? rfq?.data?.sales_lead_username : "",
      );
      setValue(
        "sales_lead_phone",
        rfq?.data?.sales_lead_phone ? rfq?.data?.sales_lead_phone : "",
      );

      // const transformedCustomFields = (rfq?.data?.custom_fields || []).map(field => ({
      //   field_name: field.name,
      //   type: field.type,
      //   value: field.value,
      // }));

      // setValue("custom_fields", transformedCustomFields);

      setValue("custom_fields", rfq?.data?.custom_fields || []);
      setValue(
        "contractPocPhone",
        rfq?.data?.point_of_contact?.phone
          ? rfq?.data?.point_of_contact?.phone
          : "",
      );
      setValue(
        "contractPocEmail",
        rfq?.data?.point_of_contact?.email
          ? rfq?.data?.point_of_contact?.email
          : "",
      );
      setValue(
        "contractPocName",
        rfq?.data?.point_of_contact?.name
          ? rfq?.data?.point_of_contact?.name
          : "",
      );

      // setValue("Valid_For", rfq?.data?.valid_for ? rfq?.data?.valid_for : "")

      rfq?.data?.RfqProducts.forEach((product, index) => {
        setValue(`cards[${index}].skuDescription`, product?.description);
        setValue(
          `cards[${index}].purchase_description`,
          product?.purchase_description,
        );
        setValue(
          `cards[${index}].vendorPartner`,
          product?.Vendor?.display_name,
        );
        setValue(`cards[${index}].skuIdUnique`, product?.sku_id);
        setValue(`cards[${index}].skuId`, product?.sku_display_name);
        setValue(`cards[${index}].rowId`, product?.raw_sku_id);
        setValue(`cards[${index}].skuLocked`, true);
        setValue(`cards[${index}].clin`, product?.clin_id);
        setValue(
          `cards[${index}].productName`,
          product?.name ?? product?.Product?.name,
        );
        setValue(
          `cards[${index}].cost`,
          trimTrailingZeros(product?.aspetto_price),
        );
        setValue(
          `cards[${index}].margin`,
          trimTrailingZeros(product?.margin_percent),
        );
        setValue(`cards[${index}].qty`, trimTrailingZeros(product?.quantity));
        setValue(`cards[${index}].um`, product?.unit_of_measure);
        setValue(`cards[${index}].customerCost`, product?.customer_price);
        setValue(`cards[${index}].totalSkuCost`, product?.total_price);
      });

      setValue(
        "shippingCost",
        rfq?.data?.shipping_cost ? rfq?.data?.shipping_cost : null,
      );
      setValue("tax", rfq?.data?.tax ? rfq?.data?.tax : null);

      setValue(
        "estimateddelivery",
        rfq?.data?.estimated_delivery ? rfq?.data?.estimated_delivery : "",
      );
      setValue(
        "payment_terms",
        rfq?.data?.payment_term ? rfq?.data?.payment_term : "",
      );
      setValue(
        "payment_term_detail",
        rfq?.data?.payment_term_detail ? rfq?.data?.payment_term_detail : "",
      );

      setValue(
        "shipping_method",
        rfq?.data?.shipping_method ? rfq?.data?.shipping_method : "",
      );
      setValue(
        "shipping_method_detail",
        rfq?.data?.shipping_method_detail
          ? rfq?.data?.shipping_method_detail
          : "",
      );
      setValue(
        "shipping_terms",
        rfq?.data?.shipping_term ? rfq?.data?.shipping_term : "",
      );

      setValue(
        "contractOfficerName",
        rfq?.data?.rfqKo?.name ? rfq?.data?.rfqKo?.name : "",
      );
      setValue(
        "contractOfficerEmail",
        rfq?.data?.rfqKo?.email ? rfq?.data?.rfqKo?.email : "",
      );
      setValue(
        "contractOfficerPhone",
        rfq?.data?.rfqKo?.phone ? rfq?.data?.rfqKo?.phone : "",
      );
      setValue(
        "contractOfficerAddress",
        rfq?.data?.rfqKo?.address ? rfq?.data?.rfqKo?.address : "",
      );

      setValue(
        "shippingCustomerName",
        rfq?.data?.rfqShipping?.name ? rfq?.data?.rfqShipping?.name : "",
      );
      setValue(
        "shippingCustomerEmail",
        rfq?.data?.rfqShipping?.email ? rfq?.data?.rfqShipping?.email : "",
      );
      setValue(
        "shippingCustomerPhone",
        rfq?.data?.rfqShipping?.phone ? rfq?.data?.rfqShipping?.phone : "",
      );
      setValue(
        "shippingCustomerAddress",
        rfq?.data?.rfqShipping?.address ? rfq?.data?.rfqShipping?.address : "",
      );

      setValue(
        "BillingCustomerName",
        rfq?.data?.rfqBilling?.name ? rfq?.data?.rfqBilling?.name : "",
      );
      setValue(
        "BillingCustomerEmail",
        rfq?.data?.rfqBilling?.email ? rfq?.data?.rfqBilling?.email : "",
      );
      setValue(
        "BillingCustomerPhone",
        rfq?.data?.rfqBilling?.phone ? rfq?.data?.rfqBilling?.phone : "",
      );
      setValue(
        "BillingCustomerAddress",
        rfq?.data?.rfqBilling?.address ? rfq?.data?.rfqBilling?.address : "",
      );
      setValue(
        "sameShipNameasKO",
        rfq?.data?.is_shipping_same_ko ? rfq?.data?.is_shipping_same_ko : "",
      );
      setValue(
        "sameBillNameasKO",
        rfq?.data?.is_billing_same_ko ? rfq?.data?.is_billing_same_ko : "",
      );
      setRfqStatus(rfq?.data?.status);
    }
  };

  const { data: rfq, postData: fetchSingleProject } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_PROJECT,
  );

  const { data: notesData, postData: fetchNotes } = usePostRequest(
    API_ENDPOINTS.GET_NOTES,
  );

  const steps = [
    "General",
    "Billing & Shipping",
    "Products",
    // "Price Change",
    "Attachments",
    "Notes",
    "Communication",
  ];

  const [currentStep, setCurrentStep] = useState(1);

  const methods = useForm({
    // resolver: yupResolver(schema),
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      shippingCostEnabled: true,
      taxEnabled: true,
      tax: parseFloat("0.00"),
      shippingCost: parseFloat("0.00"),
      notifyEmailsVendor: "0",
      notifyEmails: "0",
      // sales_lead_email: ,
      // sales_lead_name : ,
      // sales_lead_phone: ,
    },
  });

  const {
    handleSubmit,
    setError,
    reset,
    setValue,
    watch,
    getValues,
    formState: { errors },
  } = methods;

  const watchedContractVehicleType = watch("contract_vehicle_type");

  useEffect(() => {
    if (watchedContractVehicleType !== contractVehicleTypeState) {
      setContractVehicleTypeState(watchedContractVehicleType);
    }
  }, [watchedContractVehicleType, contractVehicleTypeState]);

  console.log("errors =>", errors);
  // console.log("values =>", getValues());
  const onError = (error) => {
    if (error?.errors) {
      const updatedErrors = {};
      Object.keys(error.errors).forEach((field) => {
        if (error.errors[field]?.message) {
          updatedErrors[field] = {
            message: error.errors[field]?.message,
          };
        }
      });

      setServerErr((prevState) => ({
        ...prevState,
        ...updatedErrors,
      }));
      setShow(true);
    }
    // toast.error(error?.message);
    toast.error(`${error?.message}${error?.error ? ` (${error.error})` : ""}`);
  };

  const { isLoading: createLoading, postData: createProject } = usePostRequest(
    API_ENDPOINTS.CREATE_PROJECT,
  );

  const { isLoading: notesLoading, postData: createNotes } = usePostRequest(
    API_ENDPOINTS.CREATE_NOTES,
  );

  const { isLoading: UpdateLoading, postData: updateProject } = usePostRequest(
    API_ENDPOINTS.UPDATE_PROJECT,
  );

  const { isLoading, postData: uploadImage } = usePostRequest(
    API_ENDPOINTS.UPLOAD_RFQ_IMG,
  );

  const formatPhone = (phone) => {
    if (!phone) return null;

    // Check if phone starts with '+'
    const startsWithPlus = phone.startsWith("+");

    // Remove all non-digit characters
    const cleaned = phone.replace(/\D/g, "");

    // Add '+' back if it was there
    return startsWithPlus ? `+${cleaned}` : cleaned ? cleaned : null;
  };

  const onSubmit = (data) => {
    // console.log("data", data)

    const custom_fieldsTransformed = data?.custom_fields?.map((fields) => {
      if (fields?.type === "Date" || fields?.type === "date") {
        return {
          type: fields?.type,
          value: moment(fields?.value).format("YYYY-MM-DD"),
          field_name: fields?.field_name,
        };
      } else if (fields?.type === "dropdown") {
        return {
          type: fields?.type,
          field_name: fields?.field_name,
          value: fields?.value || "",
          options: Array.isArray(fields?.options) ? fields.options : [],
        };
      } else {
        return {
          type: fields?.type,
          value: fields?.value,
          field_name: fields?.field_name,
        };
      }
    });

    const transformedProducts =
      data?.cards?.map((product) => {
        return {
          vendor_name: product?.vendorPartner,
          sku_id: product?.skuIdUnique,
          sku_display_name: product?.skuId,
          name: product?.productName ? product?.productName : null,
          clin_id: product?.clin ? product?.clin : null,
          description: product?.skuDescription ? product?.skuDescription : null,
          raw_sku_id: product?.rowId,
          purchase_description: product?.purchase_description
            ? product?.purchase_description
            : null,
          quantity: product?.qty ? product?.qty : 0,
          aspetto_price: product?.cost ? Number(product?.cost) : 0,
          customer_price: product?.customerCost
            ? Number(product?.customerCost)
            : Number(0),
          margin_percent: product?.margin ? Number(product?.margin) : 0,
          // total_price: product?.totalSkuCost ? Number(product?.totalSkuCost) : 0,
          um: product?.um,
        };
      }) || [];

    const payload = {
      attachment_id: formId,
      opportunity_type: data?.opportunityType
        ? data?.opportunityType
        : "PROJECT",
      opportunity_name: data?.opportunityName ? data?.opportunityName : null,
      // initial_consolidation: Number(data?.initial_consolidation),
      rfq_id: data?.rfqId || rfq_id,
      parent_cv_id: Number(data?.contractVehicle) || 0,
      published_date: moment(data?.publishedDate).format("YYYY-MM-DD"),
      due_date: data?.due_date
        ? moment(data.due_date).format("YYYY-MM-DD")
        : null,
      start_date: moment(data?.start_date).format("YYYY-MM-DD"),
      letter: data?.code ? data?.code : null,
      // contracting_emails: data?.emails ? data?.emails : null,
      order_type: data?.ordertype ? data?.ordertype : null,
      order_payment_type: data?.order_Payment_Type
        ? data?.order_Payment_Type
        : null,
      sales_lead_name: data?.sales_lead_name ? data?.sales_lead_name : null,
      sales_lead_email: data?.sales_lead_email ? data?.sales_lead_email : null,
      sales_lead_phone: data?.sales_lead_phone ? data?.sales_lead_phone : null,
      sales_lead_username: data?.sales_lead_username
        ? data?.sales_lead_username
        : null,
      organization_name: data?.organization_name
        ? data?.organization_name
        : null,
      brief: data?.Opportunity_Description
        ? data?.Opportunity_Description
        : null,
      estimated_delivery: data?.estimateddelivery
        ? data?.estimateddelivery
        : null,
      payment_term: data?.payment_terms ? data?.payment_terms : null,
      payment_term_detail: data?.payment_term_detail
        ? data?.payment_term_detail
        : null,
      shipping_method: data?.shipping_method ? data?.shipping_method : null,
      shipping_method_detail: data?.shipping_method_detail
        ? data?.shipping_method_detail
        : null,
      shipping_term: data?.shipping_terms ? data?.shipping_terms : null,
      valid_for: data?.Valid_For ? data?.Valid_For : null,
      is_draft: data.isDraft ? data.isDraft : false,
      shipping_cost: data?.shippingCost ? Number(data?.shippingCost) : 0,
      tax: data?.tax,

      ko_detail: {
        name: data?.contractOfficerName ? data?.contractOfficerName : null,
        email: data?.contractOfficerEmail ? data?.contractOfficerEmail : null,
        // phone: data?.contractOfficerPhone ? data?.contractOfficerPhone : null,
        phone: formatPhone(data?.contractOfficerPhone),
        address: data?.contractOfficerAddress
          ? data?.contractOfficerAddress
          : null,
      },

      shipping_detail: {
        name: data?.shippingCustomerName ? data?.shippingCustomerName : null,
        email: data?.shippingCustomerEmail ? data?.shippingCustomerEmail : null,
        // phone: data?.shippingCustomerPhone ? data?.shippingCustomerPhone : null,
        phone: formatPhone(data?.shippingCustomerPhone),
        address: data?.shippingCustomerAddress
          ? data?.shippingCustomerAddress
          : null,
      },
      billing_detail: {
        name: data?.BillingCustomerName ? data?.BillingCustomerName : null,
        email: data?.BillingCustomerEmail ? data?.BillingCustomerEmail : null,
        // phone: data?.BillingCustomerPhone ? data?.BillingCustomerPhone : null,
        phone: formatPhone(data?.BillingCustomerPhone),
        address: data?.BillingCustomerAddress
          ? data?.BillingCustomerAddress
          : null,
      },

      status: rfqstatus ? rfqstatus : "DRAFT",
      otherCost: data?.otherCost,
      contract_vehicle_type: data?.contract_vehicle_type,
      products: [...transformedProducts],
      total_cost_before_margin: data?.totalCostBeforeMargin
        ? Number(data?.totalCostBeforeMargin)
        : null,
      total_cost_after_margin: data?.totalCostAfterMargin
        ? Number(data?.totalCostAfterMargin)
        : null,

      team_emails: data?.notification_emails?.length
        ? data.notification_emails.join(",")
        : null,

      rfq_won_notification_emails: data?.rfqwon_notification_emails?.length
        ? data.rfqwon_notification_emails.join(",")
        : null,

      order_pending_notification_emails: data?.orderpending_notification_emails
        ?.length
        ? data.orderpending_notification_emails.join(",")
        : null,
      order_progress_notification_emails: data
        ?.orderprogress_notification_emails?.length
        ? data.orderprogress_notification_emails.join(",")
        : null,
      notify_emails: data?.notifyEmails ? data?.notifyEmails : 0,
      notify_emails_vendor: data?.notifyEmailsVendor
        ? data?.notifyEmailsVendor
        : 0,

      point_of_contact: {
        name: data?.contractPocName ? data?.contractPocName : null,
        email: data?.contractPocEmail ? data?.contractPocEmail : null,
        // phone: data?.contractPocPhone ? data?.contractPocPhone : null,
        phone: formatPhone(data?.contractPocPhone),
      },

      project_duration: data?.project_duration || null,
      project_budget: data?.project_budget || null,
      custom_fields: custom_fieldsTransformed,
      price_changes: [],
    };

    const onSuccess = (res) => {
      posthog.capture("contract_vehicle_created", {
        order_id: res?.order_id,
        contract_number: res?.rfq_id,
        created_by: user?.email,
        status: res?.status,
      });

      const notesPayload = {
        module_id: res?.rfq_id,
        module_type: "RFQ",
        notes: data.notes,
      };

      if (Array.isArray(notesPayload.notes) && notesPayload.notes.length > 0) {
        createNotes(notesPayload);
      }

      setIsModalOpen({
        show: true,
        title: "Contract Vehicle Created Successfully!",
        message: `Prepared by ${user?.username}. Project ID is ${
          res.rfq_id
        }. This Project is for ${res?.contract_type}. Created on ${moment(
          res?.created_date,
        ).format("MM/DD/YYYY")}.`,
        btntext: "Return Home",
      });
      reset();
    };

    const onSuccessUpdate = (res) => {
      const notesPayload = {
        module_id: res?.rfq_id,
        module_type: "RFQ",
        notes: data.notes,
      };
      if (Array.isArray(notesPayload.notes) && notesPayload.notes.length > 0) {
        createNotes(notesPayload);
      }
      setIsModalOpen({
        show: true,
        title: "Contract Vehicle Updated Successfully!",
        message: `Updated by ${user?.username}. Project ID is ${
          res.rfq_id
        }. This Project is for ${res?.contract_type}  Created on ${moment(
          res?.created_date,
        ).format("MM/DD/YYYY")}.`,
        btntext: "Return Home",
      });
      reset();
    };

    if (rfq && rfq_id) {
      updateProject(payload, onSuccessUpdate, onError);
    } else {
      createProject(payload, onSuccess, onError);
    }
  };

  // useEffect(() => {
  //   if (rfqCopy && !rfqDataFetchedcopy) {
  //     let rfq_id = rfqCopy;
  //     fetchSingleRfq({ rfq_id }, onCopyRfqSuccess);
  //     setRfqDataFetchedcopy(true);
  //   } else {
  //     setInitialVal(0);
  //   }
  // }, [rfqCopy, rfqDataFetchedcopy, fetchSingleProject]);

  useEffect(() => {
    if (rfq_id && !rfqDataFetched) {
      fetchSingleProject(
        { rfq_id, route_name: "edit", route_type: "cv" },
        onSingleProjectSuccess,
      );
      setRfqDataFetched(true);
      setIsEditing(true);
    }
    //  else {
    //   setInitialVal(0);
    // }
  }, [rfq_id, rfqDataFetched, fetchSingleProject]);

  useEffect(() => {
    if (rfq_id && !rfqDataFetched) {
      fetchNotes(
        {
          module_id: rfq_id,
          module_type: "RFQ",
        },
        onSingleNotesSuccess,
      );
    }
  }, [rfq_id, fetchNotes]);

  const handleStepChange = useCallback(
    (type) => {
      if (type === "next") {
        const currentData = methods.getValues();
        console.log("currunt step data", currentData);
        const fieldsToValidate = getFieldsForCurrentStep(currentStep);
        methods.trigger(fieldsToValidate).then((isValid) => {
          if (isValid) {
            if (currentStep <= steps.length - 1) {
              setCurrentStep((prev) => prev + 1);
            }
          } else {
            console.log("Errors:", methods.formState.errors);
          }
        });
      } else {
        if (currentStep > 1) {
          setCurrentStep((prev) => prev - 1);
        }
      }
    },
    [currentStep, methods],
  );

  // useEffect(() => {
  //   const handleKeyDown = (event) => {
  //     if (event.key === "ArrowRight") {
  //       handleStepChange("next");
  //     } else if (event.key === "ArrowLeft") {
  //       handleStepChange("prev");
  //     }
  //   };

  //   document.addEventListener("keydown", handleKeyDown);
  //   return () => {
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, [handleStepChange]); // rebind listener when handleStepChange changes

  // if (rfq_id) {
  //   steps.push("Communication");
  // }

  useEffect(() => {
    if (user) {
      setValue("sales_lead_name", `${user?.first_name} ${user?.last_name}`);
      setValue("sales_lead_email", user?.email);
      setValue("sales_lead_phone", user?.phone);
      setValue("sales_lead_username", user?.username);
    }
  }, [user]);

  const handleTabChange = (tabIndex) => {
    if (rfq_id) {
      const fieldsToValidate = getFieldsForCurrentStep(currentStep);
      methods.trigger(fieldsToValidate).then((isValid) => {
        if (isValid) {
          setCurrentStep(tabIndex);
        } else {
          console.log("Validation failed for step:", currentStep);
        }
      });
    }
  };

  useEffect(() => {
    if (!rfq_id) {
      reset({
        ...getValues(),
        sales_lead_name: `${user?.first_name} ${user?.last_name}`,
        sales_lead_email: user?.email,
        sales_lead_phone: user?.phone,
        sales_lead_username: user?.username,
      });
      setCurrentStep(1);
    } else {
    }
  }, [rfq_id, location.pathname]);

  const getFieldsForCurrentStep = (step, rfq_id) => {
    switch (step) {
      case 1:
        return [
          "opportunityName",
          "rfqId",
          "code",
          "contractVehicle",
          "organization_name",
          "Opportunity_Description",
          "publishedDate",
          "start_date",
          "due_date",
          "project_duration",
          "project_budget",
          "contract_vehicle_type",
          "custom_fields",
        ];
      case 2:
        return [
          // "shipping_method",
          "shipping_method_detail",
          "payment_term_detail",

          "contractOfficerName",
          "contractOfficerEmail",
          "contractOfficerPhone",
          "contractOfficerAddress",

          "shippingCustomerName",
          "shippingCustomerEmail",
          "shippingCustomerPhone",
          "shippingCustomerAddress",

          "BillingCustomerName",
          "BillingCustomerEmail",
          "BillingCustomerPhone",
          "BillingCustomerAddress",
        ];
      case 3:
        return ["cards", "otherCost"];
      // case 4:
      //   return [];
      case 4:
        return ["notes"];

      case 5:
        if (rfq_id !== undefined && step === 6) {
          return [
            // "sales_lead_username",
            "sales_lead_phone",
            "sales_lead_email",
            "sales_lead_name",
          ];
        } else {
          // console.log("no rfq_id");
          return [];
        }

      default:
        return [];
    }
  };

  useEffect(() => {
    const newFormId = generateUniqueId();
    setFormId(newFormId);
    reset();
  }, []);

  return (
    <>
      <SuccsessMsgModal
        show={isModalOpen.show}
        onHide={() =>
          setIsModalOpen(
            { ...isModalOpen, show: false },
            navigate("/list-contract-vehicles"),
          )
        }
        title={isModalOpen.title}
        btntext={isModalOpen.btntext}
        message={isModalOpen.message}
      />
      <div className="page-header d-none d-sm-block">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h2 className="page-title">
              {isEditing
                ? "Update Contract Vehicle"
                : "Create Contract Vehicle"}
            </h2>
          </div>
          <div>
            <Form.Group>
              {/* <Form.Label>Status</Form.Label> */}
              <InputGroup>
                <Form.Select
                  className={`Status_select`}
                  value={rfqstatus}
                  onChange={handleStatusChange}
                >
                  <option value="DRAFT">DRAFT</option>
                  <option value="PENDING">PENDING</option>
                  <option value="ACTIVE">ACTIVE</option>
                  <option value="COMPLETED">COMPLETED</option>
                </Form.Select>
              </InputGroup>
            </Form.Group>
          </div>
        </div>
      </div>

      <Card className="pt-3 pb-4 mt-5 mt-sm-0">
        <Card.Body>
          <div className="page-header d-block d-sm-none text-center">
            <h2 className="page-title justify-content-center">
              {/* Create Opportunity */}
            </h2>
          </div>

          <Stepper
            steps={steps}
            currentStep={currentStep}
            onTabClick={rfq_id ? handleTabChange : undefined}
          />
          <FormProvider
            {...methods}
            className=""
            onSubmit={methods.handleSubmit(onSubmit)}
          >
            <Form autoComplete="off" onSubmit={methods.handleSubmit(onSubmit)}>
              {currentStep === 1 && (
                <GeneralInformation
                  isEditing={isEditing}
                  contract_id={contractTypeId}
                />
              )}
              {currentStep === 2 && (
                <PaymentAndShippingForm initialVal={initialVal} />
              )}
              {currentStep === 3 && <OtherDetailsForm />}
              {/* {currentStep === 4 && <PriceChange />} */}
              {currentStep === 4 && <Attachment attachmnetid={formId} />}
              {currentStep === 5 && (
                <Notes module_type={"RFQ"} module_id={rfq_id} />
              )}
              {currentStep === 6 && <SalesLead />}
              <div className="server_error">
                {show && (
                  <>
                    <Alert
                      variant="danger"
                      onClose={() => setShow(false)}
                      dismissible
                    >
                      <Alert.Heading>Validation Errors!</Alert.Heading>
                      {Object.keys(serverErr).map((field) => (
                        <p
                          key={field}
                          style={{ color: "red", marginBottom: "5px" }}
                        >
                          {serverErr[field]?.message}
                        </p>
                      ))}
                    </Alert>
                  </>
                )}
              </div>
              <div className="d-flex justify-content-center gap-3 mt-3">
                {currentStep > 1 && (
                  <Button
                    variant="outline-secondary"
                    onClick={() => handleStepChange("prev")}
                  >
                    <IconArrowNarrowLeftDashed /> Back
                  </Button>
                )}
                {rfq_id
                  ? currentStep < 6 && (
                      <Button
                        variant="warning"
                        onClick={() => handleStepChange("next")}
                      >
                        Next <IconArrowNarrowRightDashed />
                      </Button>
                    )
                  : currentStep < 6 && (
                      <Button
                        variant="warning"
                        onClick={() => handleStepChange("next")}
                      >
                        Next <IconArrowNarrowRightDashed />
                      </Button>
                    )}

                {rfq_id
                  ? currentStep < steps.length && (
                      <div className="d-flex">
                        <Button variant="success" type="submit">
                          {createLoading || UpdateLoading ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Update"
                          )}
                        </Button>
                      </div>
                    )
                  : null}

                {rfq_id
                  ? currentStep === 6 && (
                      <div className="d-flex">
                        <Button
                          variant="warning"
                          type="submit"
                          disabled={createLoading || UpdateLoading}
                        >
                          {createLoading || UpdateLoading ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Submit"
                          )}
                        </Button>
                      </div>
                    )
                  : currentStep === 6 && (
                      <div className="d-flex">
                        <Button
                          variant="warning"
                          type="submit"
                          disabled={createLoading || UpdateLoading}
                        >
                          {createLoading || UpdateLoading ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Submit"
                          )}
                        </Button>
                      </div>
                    )}
              </div>
            </Form>
          </FormProvider>
        </Card.Body>
      </Card>
    </>
  );
}

export default CreateProject;
